/**
 * Puzzle reveal overlay — paints the pieces earned so far and glows the new one.
 *
 * Pieces are absolutely positioned by percentage inside a square board, using the
 * bounding boxes emitted when the source image was cut, so overlapping jigsaw tabs
 * land exactly where they did in the original picture.
 */

import { gameImageUrl } from "../assets/game-image-urls.js";
import {
  PUZZLE_PIECE_COUNT,
  PUZZLE_PIECE_LAYOUT,
  PUZZLE_REVEAL_HEADLINES,
} from "../config/puzzle-reward.js";

/** ms the newly landed piece keeps its highlight glow before settling. */
export var PUZZLE_REVEAL_GLOW_MS = 1600;

/**
 * @param {HTMLElement | null | undefined} board
 * @param {number} pieceCount how many pieces the player now owns (1-based count)
 */
export function renderPuzzleBoard(board, pieceCount) {
  if (!board) return;
  var owned = Math.max(0, Math.min(PUZZLE_PIECE_COUNT, Math.floor(Number(pieceCount) || 0)));
  board.textContent = "";
  for (var i = 0; i < owned; i++) {
    var spec = PUZZLE_PIECE_LAYOUT[i];
    if (!spec) continue;
    var img = document.createElement("img");
    img.className = "puzzle-reveal-overlay__piece";
    if (i === owned - 1) img.classList.add("puzzle-reveal-overlay__piece--new");
    img.alt = "";
    img.setAttribute("aria-hidden", "true");
    img.decoding = "async";
    img.src = gameImageUrl(spec.key);
    img.style.left = spec.left + "%";
    img.style.top = spec.top + "%";
    img.style.width = spec.width + "%";
    img.style.height = spec.height + "%";
    // Stack later pieces above earlier ones so overlapping tabs read correctly.
    img.style.zIndex = String(i + 1);
    board.appendChild(img);
  }
}

/**
 * @param {number} pieceCount
 * @returns {string}
 */
export function puzzleRevealHeadline(pieceCount) {
  var idx = Math.max(1, Math.min(PUZZLE_PIECE_COUNT, Math.floor(Number(pieceCount) || 1)));
  return PUZZLE_REVEAL_HEADLINES[idx - 1] || PUZZLE_REVEAL_HEADLINES[0];
}

/**
 * @param {number} pieceCount
 * @returns {string}
 */
export function puzzleRevealCountLabel(pieceCount) {
  var owned = Math.max(0, Math.min(PUZZLE_PIECE_COUNT, Math.floor(Number(pieceCount) || 0)));
  return owned + " / " + PUZZLE_PIECE_COUNT;
}
